import { Component, ElementRef, Inject, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { DateRangeInterval } from '../../../core/components/date-range/date-range.component';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { RememberService } from '../../../core/services/remember.service';
import { TTViewNavigator, TT_VIEW_NAVIGATOR, useNavigatorFor } from '../../../modal/state-modal/state-modal.component';
import { Base64UrlService } from '../../../services/base64url.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';

@Component({
    selector: 'tt-csv-export-arg',
    templateUrl: './csv-export-arg.component.html',
    styleUrls: ['./csv-export-arg.component.css'],
    standalone: false,
})
export class CsvExportArgComponent implements OnInit {
    @Input()
    public params?: GetCsvExportArgParams;

    public companyButtons: FormButton[] = [{ id: 'erase', type: 'danger', icon: 'fa fa-eraser', onClick: () => this.clear('businessco_no') }];

    public page?: CsvExportArgGet;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    @ViewChild('export')
    public exportAnchor?: ElementRef<HTMLAnchorElement>;

    public creatingFile = false;
    
    constructor(
        private base64: Base64UrlService,
        private modal: ModalService,
        private datatask: DataTaskService,
        private logistic: LogisticService,
        private rememberService: RememberService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }
    
    private async loadPage() {
        if (!!this.params) {
            this.page = (await this.datatask.Post(1527, this.params))[0];
        }
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies('1');
    }

    private async loadStockPlaces() {
        if (!this.page) return;

        if (!!this.page.businessco_no) {
            this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.page.businessco_no });
        }
    }

    public async createFile() {
        if (!this.page) return;

        if (!!this.page.p2_exportproc_keyno) {
            try {
                this.creatingFile = true;

                const response = (await this.datatask.Post(1528, { p2_exportproc_keyno: this.page.p2_exportproc_keyno }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response?.errormessage
                    });
                } else {
                    if (!this.exportAnchor?.nativeElement) return;

                    const anchor = this.exportAnchor.nativeElement;
                    const text = this.base64.urlDecode(response?.filename);
                    const textData = new Blob([text], { type: 'text/txt' });
                    const textUrl = URL.createObjectURL(textData);

                    anchor.href = textUrl;
                    anchor.download = response?.filename;
                    anchor.click();
                }
            } finally {
                this.creatingFile = false;
            }
        }
    }

    private async clear(id: string) {
        if (!this.page) return;

        switch (id) {
            case 'businessco_no':
                this.page.businessco_no = '99999';

                this.rememberService.remember('w_csvexport.businessco_no', this.page.businessco_no);
                await this.loadStockPlaces();
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof CsvExportArgGet) {
        if (!this.page) return;

        switch (id) {
            case 'businessco_no':
                this.loadStockPlaces();
                break;
            default:
                break;
        }
    }
    
    private async init() {
        await this.loadPage();
        this.loadCompanies();
        this.loadStockPlaces();
    }
    
    ngOnInit() {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;

            this.init();
        }
    }
}

interface GetCsvExportArgParams {
    argtype: string;
    argvalue: string;
    p2_exportproc_keyno: string;
}

interface CsvExportArgGet {
    argtype: string;
    argvalue: string;
    p2_exportproc_keyno: string;
    p2_exportproc_name: string;
    show_arg_datefomtom: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    show_arg_businessco_no: string;
    businessco_no: string;
    show_arg_stockplace_id: string;
    stockplace_id: string;
    show_arg_searchtext: string;
    searchtext: string;
    show_arg_supplier_no: string;
    supplier_no: string;
    show_arg_project_keyno: string;
    project_keyno: string;
    show_arg_cust_no: string;
    cust_no: string;
    show_arg_labour_no: string;
    labour_no: string;
}
